import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useCollectionUpdateLabelMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      labelId,
      text,
    }: {
      labelId: string;
      text: string;
    }) => {
      return await collectionApiClient.updateLabel(labelId, text);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["collection-labels"] });
    },
    onError: (error) => {
      console.error("Failed to update label:", error);
    },
  });
};

export default useCollectionUpdateLabelMutation;
